module.exports = __webpack_public_path__ + "static/media/iconOne.53108e60.svg";